export const NEWSLETTERS_NAMES = {
  goodDeals: 'good_deals',
  sletter: 'sletter',

  // #LIF-406 Should be removed after newsletter migration to Braze
  bestDeals: 'bon_plan',
}
